function Footer() {
  return (
    <footer className="h-12 border-t border-slate-200 bg-white flex items-center justify-between px-6 flex-shrink-0">
      <span className="text-xs text-slate-400">
        © {new Date().getFullYear()} Admin Panel. All rights reserved.
      </span>
     
    </footer>
  );
}

export default Footer;